var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit')}}},[_c('one-page-section',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }